(function () {
    'use strict';

    angular
        .module('app.clubAdmin')
        .component('sc3CreditAdjustmentModal', {
            templateUrl: 'app/club-admin/club-info/club-stats/credit-adjustment-modal.component.html',
            controller: CreditAdjustmentModal,
            bindings: { close: '&', dismiss: '&', resolve: '<' }
        });

    CreditAdjustmentModal.$inject = [];
    function CreditAdjustmentModal() {
        var ctrl = this;
        ctrl.$onInit = init;
        ctrl.submit = submit;
        ctrl.validateAdjustment = validateAdjustment;

        function init() {
            ctrl.model = ctrl.resolve.model;
        }

        function submit() {
            if (ctrl.form.$valid) 
                ctrl.close({ $value: ctrl.model });
        }

        function validateAdjustment(value) {
            return !(value + ctrl.model.credits < 0)
        }
    }
})();